import React from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import I18n from "i18next";
import thresholdCardsRawData from "data/threshold.json";

import ThresholdRow from "./ThresholdRow";

const sx = {
  thresholdsWrapper: {
    marginTop: "60px"
  },
  title: {
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "20px",
    color: "darkBlue.c100",
    marginBottom: "30px"
  }
};

export default function ThresholdsMain({ onChange, values, disabled }) {
  return (
    <Box sx={sx.thresholdsWrapper}>
      <Typography sx={sx.title}>{I18n.t("monitoringConfiguration.thresholdsAvailableItems")}</Typography>
      {thresholdCardsRawData?.map((card) => {
        const selectedValue = values?.[card.key] || "";
        return (
          <ThresholdRow
            {...card}
            disabled
            onChange={(_, value) => {
              if (disabled) return;
              onChange({ key: card.key, value });
            }}
            value={selectedValue}
          />
        );
      })}
    </Box>
  );
}
